module.exports = __webpack_public_path__ + "static/media/1015056.d1cdd6f0.jpg";